import {createAsyncThunk} from '@reduxjs/toolkit'
import AxiosClient from '../AxiosClient'

export const getCustomersAsync = createAsyncThunk(
  'orders/getCustomersAsync',
  async function (params: any, toolkit) {
    return await AxiosClient('GET', `/superadmin/users-list`, [], toolkit, params, toolkit.signal)
  }
)

export const getCustomerChannelsAsync = createAsyncThunk(
  'orders/getCustomerChannelsAsync',
  async function (_, toolkit) {
    return await AxiosClient('GET', `/available-platform`, [], toolkit, [])
  }
)

export const getBillingPlansAsync = createAsyncThunk(
  'orders/getBillingPlansAsync',
  async function (params: any, toolkit) {
    return await AxiosClient('GET', `/superadmin/billing-plans`, [], toolkit, params)
  }
)

export const getConnectedPlatformsAsync = createAsyncThunk(
  'orders/getConnectedPlatformsAsync',
  async function (params: any, toolkit) {
    return await AxiosClient('GET', `/superadmin/connected-platforms`, [], toolkit, params || {})
  }
)

export const getCustomersSearchAsync = createAsyncThunk(
  'orders/getCustomersAsync',
  async function (params: any, toolkit) {
    return await AxiosClient('GET', `/superadmin/customer-list`, [], toolkit, params )
  }
)

export const updateCustomerStatusAsync = createAsyncThunk(
  'orders/updateCustomerStatusAsync',
  async function (payload: {user_id:number, status:'active'|'inactive'}, toolkit) {
    return await AxiosClient('POST', `/superadmin/update-status`, payload, toolkit, [] )
  }
)


export const updateCustomerStatusunlockAsync = createAsyncThunk(
  'orders/updateCustomerStatusAsync',
  async function (payload: {user_id:number, status:string}, toolkit) {
    return await AxiosClient('POST', `/superadmin/update-status`, payload, toolkit, [] )
  }
)

export const loginAsCustomerAsync = createAsyncThunk(
  'orders/loginAsCustomerAsync',
  async function (payload: {user_id:number}, toolkit) {
    return await AxiosClient('POST', `/superadmin/login-as-user`, payload, toolkit, [] )
  }
)

export const getCustomerReportAsync = createAsyncThunk(
  'orders/getCustomerReportAsync',
  async function (params: any, toolkit) {
    return await AxiosClient('GET', `/superadmin/reports?page_limit=100&page_num=1`, [], toolkit, params )
  }
)

export const updateCustomerProductModule = createAsyncThunk(
  'orders/updateCustomerProductModule',
  async function (payload: any, toolkit) {
    return await AxiosClient('PUT', `/superadmin/users-list`, payload, toolkit, [] )
  }
)

export const deleteUserAsync = createAsyncThunk(
  'user/deleteUserAsync',
  async function (payload: any, toolkit) {
    return await AxiosClient('DELETE', `/superadmin/users-list`, payload, toolkit, [] )
  }
)

export type SubscriptionTimelineOrder = 'asc' | 'desc'

export const getSubscriptionTimelineAsync = createAsyncThunk(
  'customer/getSubscriptionTimelineAsync',
  async function (
    payload: { userId: number; order?: SubscriptionTimelineOrder },
    toolkit
  ) {
    return await AxiosClient(
      'GET',
      `/superadmin/subscription-timeline/${payload.userId}`,
      [],
      toolkit,
      { order: payload.order ?? 'desc' }
    )
  }
)
